import { css } from '@emotion/core'
import { Link } from 'gatsby'
import React from 'react'
import Band from '../components/band'
import ImageViewer from '../components/image-viewer'
import Layout from '../components/layout'
import img1 from '../images/1.jpg'
import img10 from '../images/10.jpg'
import img11 from '../images/11.jpg'
import img12 from '../images/12.jpg'
import img13 from '../images/13.jpg'
import img14 from '../images/14.jpg'
import img15 from '../images/15.jpg'
import img16 from '../images/16.jpg'
import img17 from '../images/17.jpg'
import img18 from '../images/18.jpg'
import img19 from '../images/19.jpg'
import img2 from '../images/2.jpg'
import img20 from '../images/20.jpg'
import img21 from '../images/21.jpg'
import img3 from '../images/3.jpg'
import img4 from '../images/4.jpg'
import img5 from '../images/5.jpg'
import img6 from '../images/6.jpg'
import img7 from '../images/7.jpg'
import img8 from '../images/8.jpg'
import img9 from '../images/9.jpg'

const Zine = () => {
  return (
    <Layout>
      <Band
        left={
          <Link
            css={css`
              font-size: 1.5rem;
              font-weight: 900;
              text-decoration: none;
            `}
            to="/"
          >
            <span
              css={css`
                color: orchid;
              `}
            >
              ⥺
            </span>
          </Link>
        }
      >
        universet er en fælled // center for militant futurologi
      </Band>
      <ImageViewer
        images={[
          img1,
          img2,
          img3,
          img4,
          img5,
          img6,
          img7,
          img8,
          img9,
          img10,
          img11,
          img12,
          img13,
          img14,
          img15,
          img16,
          img17,
          img18,
          img19,
          img20,
          img21,
        ]}
      />
      )
    </Layout>
  )
}

export default Zine
